import { useIntl } from 'react-intl';
import { Selector } from 'sonata-react-components';

import type { SelectorOptionPropsInterface } from 'sonata-react-components';

type Props = {
  campaigns?: { _id: string; name: string }[];
  id: string;
  onFilterStatus?: (state: { id: string; value: any }[]) => { id: string; value: any }[];
  value?: string[];
};

export default function CampaignPlan({ campaigns, id, onFilterStatus, value }: Props) {
  const { formatMessage } = useIntl();

  const options: SelectorOptionPropsInterface[] =
    campaigns?.map(({ _id, name }) => ({
      id: _id,
      label: name
    })) || [];

  const selectedValue: SelectorOptionPropsInterface[] =
    campaigns
      ?.filter(({ _id }) => value?.includes(_id))
      ?.map(({ _id, name }) => ({
        id: _id,
        label: name
      })) || [];

  const handleChange = (changedSelectedOptions: SelectorOptionPropsInterface[]) => {
    onFilterStatus?.([
      {
        id: 'campaignPlans',
        value: changedSelectedOptions.length
          ? changedSelectedOptions.map(({ id: selectedOptionId }) => selectedOptionId.toString())
          : undefined
      }
    ]);
  };

  return (
    <Selector<SelectorOptionPropsInterface[]>
      id={`${id}_selector`}
      label={formatMessage({
        defaultMessage: 'Campaign Plan',
        id: 'campaignPlans.filters.status.campaignPlan'
      })}
      onChange={handleChange}
      options={options}
      showDeselectOption
      showSelectedItems={false}
      type="multiple"
      value={selectedValue}
    />
  );
}
